import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import UIImage from './ui/UIImage';
import useComponent from '../../../../store/useComponent';
import RedactorEditor from '../RedactorEditor';

const initialState = {
  type: 'LoginPaywall',
  description: {
    en: 'You need to be logged in or create an account to view this content.',
    es: 'Necesitas estar logeado o crear una cuenta para ver este contenido.',
    ca: 'Necessites estar registrat o crear un compte per veure aquest contingut.',
    pt: 'Você precisa estar logado ou criar uma conta para ver este conteúdo',
  },
  background: {
    start: '#fff',
    end: '#fff',
  },
  terms: {
    en: '',
    es: '',
    ca: '',
    pt: '',
  },
  termsLink: '',
  image: {
    en: '',
    es: '',
    ca: '',
    pt: '',
  },
};

const LoginPaywall = ({ activeLanguage, components, handlerSetComponents, id }) => {
  const { data, actions } = useComponent(initialState);

  const {
    initializeComponent,
    setFormValue,
    setLocalizedValue,
  } = actions;

  const componentIndex = components.findIndex(obj => obj.id === id);
  const { component } = components[componentIndex];

  useEffect(() => {
    if (component) initializeComponent(component);
  }, []);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setFormValue(name, value);
  };

  const handleInputLocalized = (e) => {
    const { name, value } = e.target;
    setLocalizedValue(name, value, activeLanguage);
  };

  const handleRedactorLocalized = (value) => {
    setLocalizedValue('description', value, activeLanguage);
  };

  const handleImage = (imageUrl) => {
    setLocalizedValue('image', imageUrl, activeLanguage);
  };

  useEffect(() => {
    const updatedComponent = {
      id,
      component: data,
    };

    handlerSetComponents(updatedComponent, componentIndex);
  }, [data]);

  const handleBackgrounColor = (e) => {
    const { value, name } = e.target;

    const newBackground = {
      ...data.background,
      [name]: value,
    };
    setFormValue('background', newBackground);
  };

  return (
    <div className="text-black">
      <div className="flex-1 mr-4">
        <label htmlFor="description" className="block mb-2">
          <span className="uppercase tracking-wide text-gray-700 text-xs font-bold">
            Description
          </span>
          <RedactorEditor
            text={data.description[activeLanguage]}
            setText={handleRedactorLocalized}
            id={`id${activeLanguage}`}
          />
        </label>
      </div>
      <UIImage activeLanguage={activeLanguage} getImageUrl={handleImage} imageUrl={data.image} isFromPostal />
        <div className="flex-1 uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 ml-2">
            Background Gradient
          <div className="flex">
            <label htmlFor="title" className="flex-1 block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 mr-1">
              Start
              <div className="relative">
                <input
                  className="appearance-none uppercase block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  name="start"
                  type="text"
                  onChange={handleBackgrounColor}
                  value={data.background.start}
                />
                <input
                  className="absolute bg-transparent flex h-full items-center p-1 right-0 text-gray-700 top-0 cursor-pointer"
                  name="start"
                  type="color"
                  onChange={handleBackgrounColor}
                  value={data.background.start}
                />
              </div>
            </label>
            <label htmlFor="title" className="flex-1 block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 ml-1">
              End
              <div className="relative">
                <input
                  className="appearance-none uppercase block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  name="end"
                  type="text"
                  onChange={handleBackgrounColor}
                  value={data.background.end}
                />
                <input
                  className="absolute bg-transparent flex h-full items-center p-1 right-0 text-gray-700 top-0 cursor-pointer"
                  name="end"
                  type="color"
                  onChange={handleBackgrounColor}
                  value={data.background.end}
                />
              </div>
            </label>
          </div>
          </div>
      <div className="flex-1 mr-4">
        <label htmlFor="title" className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
          Terms
          <input
            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
            name="terms"
            onChange={handleInputLocalized}
            type="text"
            value={data.terms[activeLanguage]}
          />
        </label>
        <label htmlFor="url" className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
          Terms Link
          <input
            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
            name="termsLink"
            onChange={handleInput}
            type="text"
            value={data.termsLink}
          />
        </label>
      </div>
    </div>
  );
};

LoginPaywall.propTypes = {
  activeLanguage: PropTypes.oneOf(['en', 'es', 'ca', 'pt']).isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
};

export default LoginPaywall;
